<template>
  <div class="differentiating-benefits-quality-content" id="plataforma-de-marca-beneficios-diferenciadores-qualidade" data-search-anchor>
    <div class="differentiating-benefits-quality-overlay-title-image">
      <h1 class="differentiating-benefits-quality-image-quality-title" style="margin-top: 4rem;">
        {{ differentiatingBenefitsQualityImageTitle }}
      </h1>
      <h1 class="differentiating-benefits-quality-image-quality-title">
        {{ differentiatingBenefitsQualityImageTitle2 }}
      </h1>
      <h1 class="differentiating-benefits-quality-image-quality-title">
        {{ differentiatingBenefitsQualityImageTitle3 }}
      </h1>
      <h1 class="differentiating-benefits-quality-image-quality-title" style="margin-bottom: 2rem;">
        {{ differentiatingBenefitsQualityImageTitle4 }}
      </h1>
      <p class="differentiating-benefits-quality-image-quality-text">
        {{ differentiatingBenefitsQualityImageTitle5 }}
      </p>
    </div>
    <div
      class="differentiating-benefits-quality-banner-image"
      :style="{ backgroundImage: `url(${differentiatingBenefitsQualityImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import DifferentiatingBenefitsPageMixin from '@/mixins/differentiating-benefits-page-mixin'
import { DifferentiatingBenefitsPageStore } from '@/store/brand-plataform-page/differentiating-benefits-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class DifferentiatingBenefitsQualitySection extends Mixins(
  DifferentiatingBenefitsPageMixin
) {
  differentiatingBenefitsPageStore: PageStoreContract = getModule(
    DifferentiatingBenefitsPageStore,
    this.$store
  )

  get differentiatingBenefitsQualityImageTitle(): string {
    return this.getElementText(4, 0)
  }

  get differentiatingBenefitsQualityImageSrc(): string {
    return this.getElementMedia(4, 0)
  }

  get differentiatingBenefitsQualityImageTitle2(): string {
    return this.getElementText(4, 1)
  }

  get differentiatingBenefitsQualityImageTitle3(): string {
    return this.getElementText(4, 2)
  }

  get differentiatingBenefitsQualityImageTitle4(): string {
    return this.getElementText(4, 3)
  }

  get differentiatingBenefitsQualityImageTitle5(): string {
    return this.getElementText(4, 4)
  }

  async getDifferentiatingBenefitsPageStore(): Promise<void> {
    await this.differentiatingBenefitsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.differentiatingBenefitsPageStore.isLoading) {
      await this.getDifferentiatingBenefitsPageStore()
    }
  }
}
</script>

<style lang="scss">
.differentiating-benefits-quality-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;  
}

.differentiating-benefits-quality-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.differentiating-benefits-quality-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.differentiating-benefits-quality-image-quality-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.differentiating-benefits-quality-image-quality-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
